import React, { isValidElement, ReactElement, ReactNode } from "react";
import {
  Flex,
  HStack,
  IconButton,
  Spacer,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { Menu as MenuIcon } from "lucide-react";
import { MobileNavContent } from "./MobileNavContent";

export const Template: React.FC<{ children?: ReactNode }> = (props) => {
  const children = React.Children.toArray(props.children).filter<ReactElement>(
    isValidElement
  );
  const mobileNav = useDisclosure();
  return (
    <Flex py={4}>
      {children.find((child) => child.type === Brand)?.props.children}

      <HStack gap={8} display={{ base: "none", md: "flex" }}>
        {children.find((child) => child.type === Links)?.props.children}
      </HStack>
      <Spacer />
      <HStack display={{ base: "none", md: "flex" }} gap={3}>
        {children.find((child) => child.type === UserProfile)?.props.children}
      </HStack>

      <IconButton
        display={{ base: "flex", md: "none" }}
        size="sm"
        aria-label="Open menu"
        variant="ghost"
        onClick={mobileNav.onOpen}
      >
        <MenuIcon size={20} />
      </IconButton>

      <MobileNavContent isOpen={mobileNav.open} onClose={mobileNav.onClose}>
        <Stack gap={5}>
          <Flex>
            {children.find((child) => child.type === Brand)?.props.children}
          </Flex>
          <Stack>
            {children.find((child) => child.type === Links)?.props.children}
          </Stack>
          <Flex>
            {
              children.find((child) => child.type === UserProfile)?.props
                .children
            }
          </Flex>
        </Stack>
      </MobileNavContent>
    </Flex>
  );
};

const Brand: React.FC<{ children?: ReactNode }> = () => null;
const Links: React.FC<{ children?: ReactNode }> = () => null;
const UserProfile: React.FC<{ children?: ReactNode }> = () => null;

export const Navbar = Object.assign(Template, { Brand, Links, UserProfile });
